{
  "plugins": {
    "templateEngine": {
      "tqlNodes": "TQL Nodes",
      "ciTypes": "CI Types",
      "blocks": "Code blocks",
      "functions": "Functions",
      "templates": "Templates"
    },
    "copy": {
      "copied": "Copied"
    }
  }
}